/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexObjectFilesDto } from '../../models/backend-capex-object-files-dto';
import { BackendCapexObjectFilesRequestDto } from '../../models/backend-capex-object-files-request-dto';

export interface EconomicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this capex object file.
   */
  id: number;
  body: BackendCapexObjectFilesRequestDto;
}

export function economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexObjectFilesDto>;
    }),
  );
}

economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded.PATH = '/api/economic_indicators/capex_object_files/{id}/';
